export default __webpack_public_path__ + "static/media/neck.df6f16c1.png";